export default __webpack_public_path__ + "static/media/back-arrow.c64dd0e9.svg";